import { ArrowUpRight } from 'lucide-react';
import Reveal from './Reveal';
import { PRODUCTS, SITE } from '@/config/site';

export default function Products() {
  return (
    <section id="productos" data-testid="products-section" className="border-t border-white/5 bg-obsidian px-5 py-24 sm:px-10 sm:py-32">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-[10px] uppercase tracking-[0.45em] text-gold">
            <span className="h-px w-8 bg-gold/60" /> Product preview
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-4xl uppercase leading-[1.02] text-cream sm:text-6xl" data-testid="products-headline">
            Productos que <span className="italic text-silver">realmente se venden.</span>
          </h2>
        </Reveal>
        <div className="mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-4 lg:grid lg:grid-cols-3 lg:overflow-visible" data-testid="products-track">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08} className="w-[72vw] max-w-[320px] shrink-0 snap-center lg:w-auto lg:max-w-none">
              <article data-testid={`product-card-${i + 1}`} className="group relative border border-white/10 bg-noir transition-colors duration-300 hover:border-gold/50">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={p.image} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                  <span className="absolute left-4 top-4 border border-gold/40 bg-noir/60 px-2.5 py-1 text-[8px] uppercase tracking-[0.3em] text-gold backdrop-blur-sm">
                    Próximamente
                  </span>
                </div>
                <div className="flex items-center justify-between px-5 py-4">
                  <h3 className="font-display text-lg uppercase tracking-[0.08em] text-cream">{p.name}</h3>
                  <ArrowUpRight size={14} className="text-gold" />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
            <p className="text-[10px] uppercase tracking-[0.3em] text-cream/40">Colección de ejemplo · Catálogo real próximamente</p>
            <a
              data-testid="products-cta-whatsapp"
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-full bg-cream px-7 py-3.5 text-[11px] font-medium uppercase tracking-[0.25em] text-noir transition-colors duration-300 hover:bg-gold"
            >
              Pedir por WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
